import ActionResult from 'app/src/engine/action-results/ActionResult';
import HaltActionResult from 'app/src/engine/action-results/HaltActionResult';
import InstructionSegment, {
	InstructionSegmentStatus,
} from 'app/src/engine/instructions/InstructionSegment';
import MovableItem from 'app/src/engine/movable-items/MovableItem';
import GameStateStore from 'app/src/game/GameStateStore';

export default class HaltInstructionSegment extends InstructionSegment {
	public getActionResults(
		_gameStateStore: GameStateStore,
		movableItem: MovableItem,
	): { status: InstructionSegmentStatus; actionResults: ActionResult[] } {
		return {
			status: InstructionSegmentStatus.Success,
			actionResults: [new HaltActionResult(movableItem)],
		};
	}
}
